import * as actions from "actions/types";

export function startPreloader() {
  return {
    type: actions.PRELOADER_START,
    payload: true
  };
}

export function stopPreloader() {
  return {
    type: actions.PRELOADER_FINISH,
    payload: false
  };
}

export function showNotice(message) {
  return {
    type: actions.SHOW_NOTICE,
    payload: message
  };
}



// WEBPACK FOOTER //
// ./src/helpers/ActionHelper.js